import httpUtil from "@/utils/httpUtil";

export const selectOrder = params => httpUtil.get("/print/order/list", params);
